import styles from "./recurringTransfer.module.scss";
import { recurringTransferTypeColors } from "src/variable/randomColor";
import {
  activeStatusMapping,
  recurringTransferTypeMapping,
  walletSpendFrequencyMapping
} from "src/components/constant/constant";
import { getDecimalNumber } from "src/utils";
import { RecurringTransferType } from "./recurringTransferSlice";
import { Link } from "react-router-dom";
import { Status } from "src/types/commonTypes";
import { DateStack, WalletCell } from "src/components/UI/transactionCells";

const columns = [
  {
    title: "Id",
    dataIndex: "recurring_transaction_id",
    key: "recurring_transaction_id",
    render: (recurring_transaction_id: string) => (
      <Link to={`/recurring-transfer/${recurring_transaction_id}/transactions`} className={styles.tableId}>
        {recurring_transaction_id}
      </Link>
    )
  },
  {
    title: "Schedule starts at",
    dataIndex: "start_at",
    key: "start_at",
    render: (start_at: string) => <DateStack value={start_at} />
  },
  {
    title: "Next Run At",
    dataIndex: "next_run_at",
    key: "next_run_at",
    render: (next_run_at: string) => <DateStack value={next_run_at} />
  },
  {
    title: "Last Run At",
    dataIndex: "last_run_at",
    key: "last_run_at",
    render: (last_run_at: string) => <DateStack value={last_run_at} />
  },
  {
    title: "Source Card",
    dataIndex: "source_wallet_id",
    key: "source_wallet_id",
    render: (_source_wallet_id: string, data: RecurringTransferType) => (
      <WalletCell
        walletId={data?.source_wallet?.wallet_id}
        name={data?.source_wallet?.name}
        description={data?.source_wallet?.description}
      />
    )
  },
  {
    title: "Destination Card",
    dataIndex: "destination_wallet_id",
    key: "destination_wallet_id",
    render: (_destination_wallet_id: string, data: RecurringTransferType) => (
      <WalletCell
        walletId={data?.destination_wallet?.wallet_id}
        name={data?.destination_wallet?.name}
        description={data?.destination_wallet?.description}
      />
    )
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status: Status) => (
      <div className={styles.tableCardStatus}>
        <div className={`${activeStatusMapping[status] ? styles.green : styles.grey}`}>
          {activeStatusMapping[status] ? "Active" : "Archived"}
        </div>
      </div>
    )
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (amount: number) => <div style={{ color: amount > 0 ? "green" : "grey" }}>${getDecimalNumber(amount)}</div>
  },
  {
    title: "Frequency",
    dataIndex: "frequency",
    key: "frequency",
    render: (frequency: string) => walletSpendFrequencyMapping[frequency]
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    render: (type: string) => (
      <div
        className={styles.type}
        style={{
          borderColor: `${recurringTransferTypeColors[type]}73`,
          color: `${recurringTransferTypeColors[type]}FF`
        }}
      >
        {recurringTransferTypeMapping[type]}
      </div>
    )
  }
];

export default columns;
